module.exports = __webpack_public_path__ + "img/icon-globe-error.4d9d2fec.svg";